import type { WidgetId } from '@wix/members-area-app-definitions';

import { log } from '../../editor/services/monitor';
import type { RouteConfiguration } from '../../types';

export const getRouteByWidgetId = (
  widgetId: WidgetId,
  routes: RouteConfiguration[],
) => routes.find((route) => widgetId === route.widgetId);

export const logManageAndNavigateMissingDataWarning = (extra: object) => {
  log(
    'Open Manage and Navigate panel: menu and routes are out of sync / missing data',
    {
      extra,
    },
  );
};
